import React, { useContext, useEffect, useState } from "react";
import {
  Tabs,
  Tab,
  Box,
  createTheme,
  ThemeProvider,
  Divider,
  Tooltip,
} from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";
import { useTranslation } from "react-i18next";
import AppContext from "../../Contexts/AppContext";

const DictionaryTabs = ({
  tabsData,
  with_gradient = false,
  isMenu = false,
  openDrawer,
}) => {
  const { t } = useTranslation("main");

  const [value, setValue] = useState(0);
  const tabNames = Object.keys(tabsData);
  // console.log("tabNames", tabNames);
  const {
    // isWindowLayerDashboardOpen,
    setIsWindowLayerDashboardOpen,
    tabsRef,
    layersRef,
    isSelectingProject,
    // dashboardsToShow,
    // setDashboardsToShow,
  } = useContext(AppContext);

  const isMobile = window.innerWidth < 960;
  const isRotated = window.innerWidth > window.innerHeight;

  useEffect(() => {
    setValue(0);
  }, [openDrawer]);

  useEffect(() => {
    if (!isSelectingProject) return;
    setValue(0);
  }, [isSelectingProject]);

  const handleChange = (ev, newValue) => {
    let event;

    if (isMenu) {
      if (tabNames[newValue] === "dashboard") {
        console.log("ABRIR DASHBOARD");
        event = new Event("dashboard-open-request");
        setIsWindowLayerDashboardOpen(true);
      } else {
        console.log("CERRAR DASHBOARD");
        event = new Event("dashboard-close-request");
        setIsWindowLayerDashboardOpen(false);
      }
      document.dispatchEvent(event);
    }

    setValue(newValue);
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        overflow: isMobile && isRotated ? "visible" : "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Tabs
        ref={tabsRef}
        value={value}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabNames.map((name, index) => {
          return (
            <Tooltip
              title={tabsData[name].disabled ? t("unavailable") : ""}
              key={index}
            >
              <Tab
                style={{ pointerEvents: "auto" }}
                label={<strong>{t(name)}</strong>}
                disabled={tabsData[name].disabled}
              />
            </Tooltip>
          );
        })}
      </Tabs>
      <Divider />
      {tabNames.map((name, index) => (
        <div
          role="tabpanel"
          hidden={value !== index}
          id={`tabpanel-${index}`}
          key={index}
          style={{
            overflow: isMobile && isRotated ? "visible" : "auto",
          }}
        >
          {value === index && (
            <Box sx={{ p: 2 }} ref={layersRef}>
              {/* Aquí se muestra el contenido de cada pestaña */}
              {tabsData[name].render}
            </Box>
          )}
        </div>
      ))}
    </Box>
  );
};

export default DictionaryTabs;
